import * as React from 'react';
export const linkSvg = React.forwardRef(function linkSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM5.165 3.2h2.467c.608 1.856 2.3 3.469 4.384 3.795v2.007c-2.08.33-3.773 1.942-4.384 3.798H5.165C5.645 10.794 7.043 9.078 8.8 8 7.046 6.922 5.645 5.206 5.165 3.2Z',
    }),
  );
});
linkSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var link = {
  category: 'paymentmethod',
  colorable: true,
  name: 'link',
  svg: linkSvg,
};
